import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { fade } from "svelte/transition";

let nextId = 0;
const store = $.proxy({ items: [] });

export function showToast(text) {
	const id = ++nextId;

	store.items.push({ id, text });

	setTimeout(
		() => {
			const i = store.items.findIndex((t) => t.id === id);

			if (i !== -1) store.items.splice(i, 1);
		},
		2400
	);
}

var root = $.from_html(`<div class="toast svelte-2tafttlsg5vcn"> </div>`);
var root_1 = $.from_html(`<div class="toasts svelte-2tafttlsg5vcn" aria-live="polite"></div>`);

export default function Toast($$anchor, $$props) {
	$.push($$props, true);

	// svelte/transition animates via JS, out of reach of the CSS
	// reduced-motion override in app.css — gate the duration here.
	const fadeMs = matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 150;

	var div = root_1();

	$.each(div, 21, () => store.items, (t) => t.id, ($$anchor, t) => {
		var div_1 = root();
		var text_1 = $.child(div_1, true);

		$.reset(div_1);
		$.template_effect(() => $.set_text(text_1, $.get(t).text));
		$.transition(3, div_1, () => fade, () => ({ duration: fadeMs }));
		$.append($$anchor, div_1);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}
import "bun-svelte:Toast.svelte-1lz6b7q82jale-style.css";